import { Flex } from '@chakra-ui/react';
import { ScrollTabs } from '~/common/components/ScrollTabs/ScrollTabs';
import { useListingPageContext } from '../../ListingPageContext';
import { SECTIONS } from '../constants';

export const ListingPageMobileHeader = () => {
  const { isViewOnly } = useListingPageContext();

  return (
    <Flex
      alignItems="center"
      bg="indigo.800"
      direction="column"
      display={!isViewOnly ? 'none' : 'flex'}
      gap={2}
      justifyContent="flex-start"
      position="sticky"
      py={3}
      top={0}
      width="100%"
      zIndex={4}
    >
      <ScrollTabs sections={SECTIONS} />
    </Flex>
  );
};
